var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { IsArray, IsInt, IsOptional, IsString, IsUUID, Matches, Min, ValidateNested, } from 'class-validator';
import { LOCAL_ISO_REGEX, RRULE_REGEX } from '../constants.js';
/**
 * Pre-flight conflict check for a candidate series.
 *
 * The candidate is described by enough fields to expand the rrule and check
 * each occurrence against existing materialized rows + virtual occurrences of
 * other series. The response is a `CheckConflictsResponseDto` listing any
 * overlaps so the form can present per-row resolution (skip / proceed / change
 * time).
 *
 * If `excludeSeriesId` is provided, virtual occurrences belonging to that
 * series are not flagged as conflicts (used during edit-all / split). Note
 * that materialized override rows of the excluded series ARE still flagged —
 * those are real bookings that the new rrule may collide with.
 */
export class CheckConflictsDto {
    rrule;
    dtstartLocal;
    tzid;
    defaultPlannedDuration;
    defaultOfficeLocationId;
    defaultTherapistId;
    defaultRoomId;
    defaultDeviceIds;
    defaultParticipantPatientIds;
    excludeSeriesId;
}
__decorate([
    IsString(),
    Matches(RRULE_REGEX, {
        message: 'rrule must be a valid RFC 5545 RRULE string',
    }),
    __metadata("design:type", String)
], CheckConflictsDto.prototype, "rrule", void 0);
__decorate([
    Matches(LOCAL_ISO_REGEX, {
        message: 'dtstartLocal must be local-time ISO `YYYY-MM-DDTHH:mm:ss` (no offset)',
    }),
    __metadata("design:type", String)
], CheckConflictsDto.prototype, "dtstartLocal", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CheckConflictsDto.prototype, "tzid", void 0);
__decorate([
    IsInt(),
    Min(1),
    __metadata("design:type", Number)
], CheckConflictsDto.prototype, "defaultPlannedDuration", void 0);
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], CheckConflictsDto.prototype, "defaultOfficeLocationId", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", Object)
], CheckConflictsDto.prototype, "defaultTherapistId", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", Object)
], CheckConflictsDto.prototype, "defaultRoomId", void 0);
__decorate([
    IsArray(),
    IsUUID('4', { each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], CheckConflictsDto.prototype, "defaultDeviceIds", void 0);
__decorate([
    IsArray(),
    IsUUID('4', { each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], CheckConflictsDto.prototype, "defaultParticipantPatientIds", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], CheckConflictsDto.prototype, "excludeSeriesId", void 0);
export class ConflictReportEntryDto {
    /** RECURRENCE-ID of the candidate occurrence (local-time ISO string). */
    occurrenceKey;
    /** UTC ISO timestamp of the candidate occurrence's start (after tzid resolution). */
    scheduledStart;
    conflicts;
}
export class CheckConflictsResponseDto {
    entries;
}
__decorate([
    ValidateNested({ each: true }),
    Type(() => ConflictReportEntryDto),
    __metadata("design:type", Array)
], CheckConflictsResponseDto.prototype, "entries", void 0);
//# sourceMappingURL=check-conflicts.dto.js.map